import { ModalContext } from 'app/app';
import axios from 'axios';
import { Pagination } from 'components/Pagination';
import {
  AccountNav,
  Animate,
  AuthContext,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import { UnlimitedCard } from 'components/unlimitedCard/card';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export function Commissions(props) {
  const { setModal } = useContext(ModalContext);
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [commissions, setCommissions] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const auth = useContext(AuthContext);
  const context = useContext(ViewContext);

  async function runAPI(page, search, firstTime) {
    setLoading(true);

    await axios
      .get(
        `/api/commission?page=${page}&search=${searchQueryString}&account_id=${auth.user.account_id}`
      )
      .then(async (res) => {
        setPayload(res.data.data);

        const helper = new DateUtils();
        const timezone = await helper.getTimezone();

        const formattedValues = res.data.data.data.map((document) => {
          return {
            id: document.id,
            name: document.name,
            uploaded_by: document.uploaded_by,
            type: document.type,
            link: document.s3_link,
            'Created At': helper.timestamp(
              document.createdAt,
              timezone
            ),
          };
        });

        setCommissions(formattedValues);
      })
      .catch((err) => {
        console.log(err);

        context.notification.show(
          'Something went wrong!',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });

    setLoading(false);
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, []);

  return (
    <Animate type="pop">
      <AccountNav />
      <UnlimitedCard>
        <Grid cols="1">
          <div className={styles.wrapper}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={commissions}
              badge={{
                col: 'status',
                condition: [
                  { value: 'Active', color: 'green' },
                  { value: 'Inactive', color: 'red' },
                ],
              }}
              show={['name', 'uploaded_by', 'Created At']}
              actions={{
                custom: [
                  {
                    icon: 'download',
                    action: (row) => {
                      window.open(row.link);
                    },
                    color: '#637381',
                    tooltip: 'Download commission',
                  },
                ],
              }}
            />
            {!loading && payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString, false);
                }}
              />
            )}
          </div>
        </Grid>
      </UnlimitedCard>
    </Animate>
  );
}
